import { Flex, SegmentGroup, Heading } from "@chakra-ui/react";
import { ITimespan, TIMESPAN_OPTIONS } from "./timespan";


function TimespanFilter({ timespan, setTimespan }: {timespan: ITimespan, setTimespan: (value: ITimespan) => void}) {
  return (
    <Flex gap={{base: 0, sm: 2 }} alignItems={{ base: "start", sm: "center"}} flexDirection={{ base: "column", sm: "row"}}>
      <Heading size="sm">Timespan</Heading>
      <SegmentGroup.Root
        size="xs"
        value={timespan}
        onValueChange={(e) => e.value && setTimespan(e.value as ITimespan)}
      >
        <SegmentGroup.Indicator bg="bg" />
        <SegmentGroup.Items cursor="pointer" items={Object.keys(TIMESPAN_OPTIONS)} />
      </SegmentGroup.Root>
    </Flex>
  );
}

export default TimespanFilter;
